export default __webpack_public_path__ + "static/AP-be342a8baed51700565999aad82da642.pdf";